export enum EResidenceCheckOutLogic {
  DEFAULT = 'default',
  DRIVER = 'driver',
  GUEST = 'guest',
}
